import React from 'react'

import SubNavigation from '../SubNavigation'

import styles from './BBFCSubNavigation.module.scss'

const BBFCSubNavigation = (props) => <SubNavigation {...props} style={styles} />

export default BBFCSubNavigation
